export function IlustracaoPredio(props) {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 32 32"
      fill="#373737"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.333 18.668H12v2.667H9.333v-2.667z" fill="#373737" />
      <path
        d="M25.333 2.667H14.667A2.668 2.668 0 0012 5.332v8H6.667A2.67 2.67 0 004 16v12c0 .736.596 1.333 1.333 1.333h21.334c.737 0 1.333-.597 1.333-1.333V5.333a2.668 2.668 0 00-2.667-2.667zm-18.666 24V16h8v10.666h-8zm12-16H16V8h2.667v2.666zM24 21.332h-2.667v-2.666H24v2.666zM24 16h-2.667v-2.667H24V16zm0-5.334h-2.667V8H24v2.666z"
        fill="#373737"
      />
    </svg>
  );
}
